<template>
  <EntryCard :entry="entry">
  <template slot="text">
    <span class="text--disabled overline mr-2">Challenge Roll</span>
    <span :class="resultClass">{{ entry.result.text }}{{ matchText }}</span>
    <span class="text--disabled caption">{{ `${ entry.result.actionDie }` }} vs {{ `${ entry.result.challenge1 }, ${ entry.result.challenge2 }` }}</span>
    <div class="my-0 py-0">
    <span v-html="entry.moveResult"></span>
    </div>
  </template>
  </EntryCard>
</template>

<script>
  import EntryCard from '@/components/entry/EntryCard'
  export default {
    components: { EntryCard },
    props: {
      entry: {
        type: Object,
      },
    },
    computed: {
      matchText() {
        if (this.entry.result.match) {
          if (this.entry.result.type == 'm') {
            return ' (COMPLICATION!)'
          } else {
            return ' (OPPORTUNITY!)'
          }
        }
        return ''
      },
      resultClass() {
        return {
          'mr-2': true,
          'font-weight-bold': true,
          'red--text': this.resultMiss,
          'green--text': this.resultStrongHit,
          'blue--text': this.resultWeakHit,
        }
      },
      resultMiss() {
        return this.entry.result.type === 'm';
      },
      resultWeakHit() {
        return this.entry.result.type === 'wh';
      },
      resultStrongHit() {
        return this.entry.result.type === 'sh';
      }
    },
  };
</script>
